import { isAttachmentUrl } from '@highlight/common/product'
import { defaultUrlTransform, type UrlTransform } from 'react-markdown'

// react-markdown blanks any URL whose protocol isn't allowlisted, which would
// strip `attachment:N` before the image and link overrides can resolve it.
export const preserveAttachmentUrls: UrlTransform = (url) => (isAttachmentUrl(url) ? url : defaultUrlTransform(url))
